/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Identifies where an investigation test result came from.
 */
export enum InvestigationResultSource {
    MANUAL = 'manual',
    DEVICE = 'device',
    EXTERNAL = 'external',
}
